import { createSelector } from 'reselect';
import { uiSelector } from '../common/state/selectors/issue-selector';

export const uiConfigSelector = createSelector(uiSelector, (ui) => ui.uiConfig);

export const isNewIssueViewLockedInSelector = createSelector(uiConfigSelector, (uiConfig) =>
	Boolean(uiConfig && uiConfig.newIssueViewLockedIn),
);
